import { MouseEvent, MutableRefObject, useMemo } from 'react';
import { useInView, IntersectionOptions } from 'react-intersection-observer';
import { Flex, Tag, TagLabel, TagProps } from '@chakra-ui/react';

interface TruncatableChipProps {
  label: string;
  containerRef: MutableRefObject<null>;
  tagProps?: TagProps;
  onClick?: (e: MouseEvent) => void;
  onChange?: IntersectionOptions['onChange'];
  dataTestId?: string;
}

export const TruncatableChip = ({
  label,
  containerRef,
  tagProps,
  onClick,
  onChange,
  dataTestId,
}: TruncatableChipProps) => {
  const inViewOptions: IntersectionOptions = useMemo(
    () => ({
      root: containerRef.current,
      initialInView: true,
      threshold: 1,
      trackVisibility: true,
      delay: 100,
      onChange,
    }),
    [containerRef, onChange]
  );

  const { ref, inView } = useInView(inViewOptions);

  return (
    <Flex alignItems="center">
      <Tag
        ref={ref}
        data-testid="chip"
        size="md"
        sx={{
          visibility: inView ? 'visible' : 'hidden',
          marginRight: 1,
          cursor: onClick ? 'pointer' : 'default',
        }}
        onClick={onClick}
        {...tagProps}
      >
        <TagLabel data-testid={dataTestId}>{label}</TagLabel>
      </Tag>
    </Flex>
  );
};
